import React, { useState } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";

import { ENABLED, EXTRACT_TEXT_VIEW } from "../../constants/Constants";
import { GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";

import extractTextService from "../../services/extractTextService";

import PrepareExtractText from "./PrepareExtractText";
import { isSilentObserverAvailable } from "../../shared/function";

const ExtractText = () => {
    const { extractTextInprogress, enableCropButton } = useSelector((state) => state.extractText);
    const localisedValues = useLanguageChange();
    const [isCapturing, setIsCapturing] = useState(false);

    // save entire / cropped image in OCR Pop up
    const saveOCRimage = (key) => {
        setIsCapturing(true);
        setTimeout(() => {
            setIsCapturing(false);
        }, 2000);
        extractTextService.saveOCRimage(key);
    };

    // exit OCR
    const exitocrcanvas = () => {
        extractTextService.exitocrcanvas();
    };

    return (
        <>
            {extractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW && (
                <PrepareExtractText showPrepareView={extractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW} />
            )}

            <div className={clsx("annotation-modal", extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW && "active")} id='extract-text-annotation'>
                <div className='annotation-modal-content'>
                    <div className='annotation-modal-body'>
                        <div className='annotation-canvas-box'>
                            <canvas style={{ display: "none" }} id='outocrcanvas'></canvas>
                        </div>
                    </div>
                    {!isSilentObserverAvailable() && (
                        <div className='annotation-action-menu'>
                            <div className='markup-menu'>
                                <div className='markup-menu-in'>
                                    {GLOBAL_MEETING_DATA.isAgent && PublicVariables.featureFlag.SHOWMESAVEOCR === ENABLED && (
                                        <div className='markup-menu-item' data-testid='extractText-action-menu'>
                                            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                                                <button className='btn markup-menu-btn' disabled={isCapturing} onClick={() => saveOCRimage("entire")}>
                                                    <span className='btn-icon icon-save-image'></span>
                                                </button>
                                                <div className='custom-tooltip-content text-nowrap'>
                                                    <div className='custom-tooltip-in'>
                                                        <p>{localisedValues?.save_image}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {GLOBAL_MEETING_DATA.isAgent && PublicVariables.featureFlag.SHOWMESAVEOCR === ENABLED && (
                                        <div className='markup-menu-item right-border'>
                                            <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                                                <button
                                                    className='btn markup-menu-btn'
                                                    disabled={!enableCropButton || isCapturing}
                                                    onClick={() => saveOCRimage("cropped")}
                                                >
                                                    <span className='btn-icon icon-save-cropped'></span>
                                                </button>
                                                <div className='custom-tooltip-content text-nowrap'>
                                                    <div className='custom-tooltip-in'>
                                                        <p>{localisedValues?.save_cropped_image}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className='markup-menu-item mob-markup-menu-item markup-menu-exit'>
                                        <div className='markup-menu-item-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width m-hide'>
                                            <button className='btn markup-menu-btn' onClick={exitocrcanvas}>
                                                <span className='btn-icon icon-close'></span>
                                                <span className='mob-btn-text'>{localisedValues?.exit}</span>
                                            </button>
                                            <div className='custom-tooltip-content text-nowrap'>
                                                <div className='custom-tooltip-in'>
                                                    <p>{localisedValues?.exit}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
// add active class in annotation-modal
export default ExtractText;
